import { ITipInterceptor } from '@tencent/pmd-types';
import { MessagePlugin } from 'tdesign-vue-next';
import { RetCode } from '../contants';

export class MessageInterceptor implements ITipInterceptor {
  interceptor(res: any): [boolean, any] {
    let stop = false;
    if (res.data?.ret === RetCode.PhoneCodeError) {
      stop = true;
      MessagePlugin.closeAll();
      MessagePlugin.error($t('验证码输入错误，请重新输入'));
    }
    if (res.data?.ret === RetCode.PhoneCodeSended) {
      stop = true;
      MessagePlugin.closeAll();
      MessagePlugin.error($t('距离上次验证码下发不足60秒，请等待'));
    }
    return [stop, res];
  }
}
